import { Inject, Pipe, PipeTransform } from '@angular/core';
import { NotificationInfoHandler, NotificationInfoTransformer } from 'src/app/core/services/notification-info-handler.service';



@Pipe({
  name: 'notificationTitle'
})
export class NotificationTitlePipe implements PipeTransform {

  constructor(private notificationInfoHandler: NotificationInfoHandler) {

  }

  transform(value: any, ...args: any[]): any {
    const handler = this.notificationInfoHandler.getTransformer(value.systemCode);
    return handler?.getTitle(value);
  }

}
